import React from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';
import { Button } from '@change-corgi/design-system-legacy/components/actions';
import { iconOutlinedFlag } from '@change-corgi/design-system-legacy/icons';
import { Flex } from '@change-corgi/design-system-legacy/layout';

import { ReportAbuseLink } from 'src/app/shared/components/abuse';
import { useReportVideo } from 'src/app/shared/hooks/report';

import type { SupporterVideo } from '../../shared/types';

type ReportVideoProps = {
	video: SupporterVideo;
	petitionId: string;
	petitionSlug: string;
};
export const ReportVideo: React.FC<ReportVideoProps> = ({ video, petitionId, petitionSlug }) => {
	const {
		data: { canReportVideo },
		actions: { report },
	} = useReportVideo({ petitionId, video });

	const { translate } = useI18n();

	if (!canReportVideo) return null;

	return (
		<Flex onClick={report}>
			<ReportAbuseLink
				type={video.videoUrl ? 'video_comment' : 'comment'}
				comment={{ id: video.id, likes: Number(video.likeCount), role: 'VIDEO_COMMENT' }}
				petitionId={petitionId}
				petitionSlug={petitionSlug}
			>
				<Button
					icon={iconOutlinedFlag}
					size="small"
					mode="icon"
					aria-label={translate('corgi.components.petition_video.actions.aria_label.report_video', {
						user_name: video.user?.shortDisplayName ?? '',
					})}
					data-testid={`supporter-video-${video.id}-report-button`}
					sx={{
						// These styles override the design-system-legacy theme because they were designed when the
						// videos feature and design systems were being redesigned. When we move fully to sunrise these
						// can be reevaluated and replaced with ds-next standard buttons.
						'& > *': { color: 'primary-black' },
						border: 'none',
						background: 'primary-greyBackground',
						'&:hover': {
							background: 'rgba(0,0,0,0.1)',
						},
					}}
				>
					Report
				</Button>
			</ReportAbuseLink>
		</Flex>
	);
};
